
import React, { useState, useEffect } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronUp, Filter, RotateCcw } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import Axios from 'axios';
import { API_BASE_URL, GET_SUPPLIER_PAYMENTS_PENDING} from '../../Config';
// import ViewPurchase from './../../core/modals/purchases/viewpurchase';
import Table from '../../core/pagination/datatable';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import { setsupplierpaymentslist_data } from '../../core/redux/action';
import ViewSupplierPayments from '../../core/modals/purchases/viewsupplierpayments';
import SpinLoader from '../loader/SpinLoader';
// import GenerateInvoicePayment from '../../core/modals/purchases/invoicepayment';


const SupplierPayments = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [viewPurchaseObj, setViewPurchaseObj] = useState([]); 
    const [paymentsData, setPaymentsData] = useState([]); 

    const navigate = useNavigate();

    // #region Session userdetails
    useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
      } else {
        navigate('/');
        console.log("User data not found in sessionStorage");
      }
    }, []);


    const dispatch = useDispatch();
    // const data = useSelector((state) => state.supplierpaymentslist_data);
    const data = useSelector((state) => state.toggle_header);

    const [loading, setLoading] = useState(false);  
    const [searchValue, setSearchValue] = useState('');
    const [filteredData, setFilteredData] = useState(paymentsData);

    
    useEffect(() => {
        if (userDataSession && userDataSession.OrgId){
            setLoading(true);
            const api = `${API_BASE_URL}${GET_SUPPLIER_PAYMENTS_PENDING}?OrgId=${userDataSession.OrgId}`;
            Axios.get(api)
            .then(response => {
                    if (response.data.Status) {
                        setPaymentsData(response.data.ResultData);
                        console.log(response.data.ResultData, 'data getting from service...');
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data);
                        setPaymentsData([]);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
            }
        }, [userDataSession]);

    useEffect(() => {
        setFilteredData(paymentsData);
    }, [paymentsData]);
    
    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearchValue(value);
        filterData(value);
    };

    const filterData = (searchText) => {
        const lowercasedSearchText = searchText.toLowerCase();
    
        const filtered = paymentsData?.filter(item => {
            const transactionNo = item.AutoGentransactionNo ? item.AutoGentransactionNo.toString() : '';
            const supplierName = item.SupplierName ? item.SupplierName.toLowerCase() : '';
            const status = item.POStatus ? item.POStatus.toLowerCase() : '';
    
            return (
                transactionNo.includes(lowercasedSearchText) ||
                supplierName.includes(lowercasedSearchText) ||
                status.includes(lowercasedSearchText)
            );
        });
        setFilteredData(filtered);
    };
    
    const columns = [
        {
            title: 'Supplier',
            dataIndex: 'SupplierName',
            key: 'SupplierName',
            render: (text) => text,
        },
        {
            title: 'Mobile',
            dataIndex: 'PhoneNo',
            key: 'PhoneNo',
            render: (text) => `${text}`,        
        },
        {
            title: 'Total Amount',
            dataIndex: 'InvoiceAmt',
            key: 'InvoiceAmt',
            render: (text) => `${text}`,        
        },
        {
            title: 'Paid Amount',
            dataIndex: 'PaidAmt',
            key: 'PaidAmt',
            render: (text) => `${text}`,        
        },
        {
            title: 'Due Amount',
            key: 'DueAmount',
            render: (record) => {
                const dueAmount = record.InvoiceAmt - record.PaidAmt;
                return dueAmount.toFixed(2);
            }
        },        
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <div>
                    <Link
                            to="#"
                            className="dropdown-toggl"
                            data-bs-toggle="dropdown"
                        >
                            <i className="fa-solid fa-ellipsis-vertical btn border"></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                        <Link to="#" className="dropdown-item"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightSuppPaysView"
                            aria-controls="offcanvasRightSuppPaysView"
                            onClick={() => showViewModal(record)}
                        >
                            <i className="fa-regular fa-eye me-2"></i>
                            View
                        </Link>
                        <Link to="#" className="dropdown-item"
                             data-bs-toggle="offcanvas"
                             data-bs-target="#offcanvasRightSuppPaysView"
                             aria-controls="offcanvasRightSuppPaysView"
                             onClick={() => showViewModal(record)}
                        >
                            <i className="fa-solid fa-coins me-2"></i>
                            Payment
                        </Link>
                    </div>
                </div>
            ),
        },
    ];

    const showViewModal = (purchaseObj) => {
        setViewPurchaseObj(purchaseObj);
    };

    // const showPaymentModal = (purchaseObj) => {
    //     setPaymentObj(purchaseObj);
    // };

    const generatePDF = () => {
        const doc = new jsPDF();
    
        // Set properties for PDF
        doc.setProperties({
          title: " Report",
          author: "Your Name",
          creator: "Your Application",
        });
    
        // Add data to PDF
        const tableData = []; // Your data array here
    
        // Add a header row
        const headers = ["PO Number", "Date", "Supplier Name", "Status"];
        tableData.push(headers);
    
        // Add rows
        filteredData.forEach((item) => {
          const row = [];
          row.push(
            `PO${item.AutoGentransactionNo}`,
            // formatDate(item.RequestDate),
            item.SupplierName,
            item.PRStatus
          );
          tableData.push(row);
        });
    
        // Generate table
        doc.autoTable({
          head: [headers],
          body: tableData.slice(1),
        });
    
        // Save the PDF
        doc.save("ProductsData.pdf");
    };
    
    const generateEXCEL = () => {
        if (filteredData.length === 0) {
            return; // Don't download if there is no data
        }

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Define headers for the worksheet
        const headers = ["PO Number", "Date", "Supplier Name", "Status"];

        // Convert your data to worksheet format
        const wsData = filteredData?.map((item) => ({
            "PO Number": `PO${item.AutoGentransactionNo}`,
            // Date: formatDate(item.RequestDate),
            "Supplier Name": item.SupplierName,
            Status: item.PRStatus,
        }));

        // Add headers as the first row
        wsData.unshift({
            "PO Number": headers[0],
            Date: headers[1],
            "Supplier Name": headers[2],
            Status: headers[3],
        });

        // Convert the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(wsData, { skipHeader: true });

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "ProductsData");

        // Save the workbook to a file
        XLSX.writeFile(wb, "ProductsData.xlsx");
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header transfer">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Supplier Payments List</h4>
                                <h6>Manage your supplier payments</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li onClick={generatePDF}>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li onClick={generateEXCEL}>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li onClick={handleReload}>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>
                    {/* /supplier payments list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        value={searchValue}
                                        onChange={handleSearchChange}
                                        className="form-control form-control-sm formsearch"
                                    />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="search-path">
                                    <Link className={`btn btn-filter`} id="filter_search" >
                                        <Filter
                                            className="filter-icon"
                                            // onClick={toggleFilterVisibility}
                                        />
                                        <span >
                                            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            {/* /Filter */}
                            <div
                                className={`card`}
                                id="filter_inputs"
                                // style={{ display: isFilterVisible ? "none" : "none" }}
                            >
                                <div className="card-body pb-0">
                                   
                                </div>
                            </div>
                            {/* /Filter */}

                            <div className="table-responsive">
                                {loading ? (
                                    <SpinLoader/>
                                    
                                    // <div className="loader m-auto"></div>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} rowKey="PurchaseId" pagination={{ pageSize: 10 }} />
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>

            <ViewSupplierPayments POObj={viewPurchaseObj} />
            {/* <GenerateInvoicePayment /> */}
        </div>
    )
}

export default SupplierPayments
